import * as core from '../../../../../../../core'

import { query } from './change-impacts-by-team.query'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts.by.team',
    description: 'Bar chart of change impacts by team',
    name: 'Change Impacts by Team',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
